import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/meta";

const stats = [
  { value: "24+", label: "收录影视作品" },
  { value: "16", label: "演员资料档案" },
  { value: "5", label: "年度更新区间" },
  { value: "6", label: "覆盖地区来源" },
];

export default function SiteIntro() {
  return (
    <section className="mx-auto w-full px-4 py-12 md:px-8 md:py-16">
      <div className="grid grid-cols-1 gap-10 rounded-lg border border-background-200 bg-background-100 p-6 md:p-10 lg:grid-cols-2 lg:gap-16">
        <div>
          <span className="inline-flex items-center gap-2 rounded-md bg-secondary-100 px-3 py-1.5 text-xs font-semibold text-secondary-900">
            <i className="ri-information-line text-sm" />
            关于本站
          </span>
          <h2 className="mt-4 font-heading text-2xl font-extrabold tracking-tight text-foreground-950 md:text-3xl">
            让每一部影视作品，都值得被认真了解
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            {siteInfo.intro}
          </p>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            我们围绕剧情介绍、演员信息与更新资讯搭建了完整的资料结构，支持按类型、地区、年份多维筛选，
            并提供关键词模糊搜索与相关推荐，帮助你更高效地找到想看的内容。
          </p>
          <Link
            to="/about"
            className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-700 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-800"
          >
            了解更多
            <i className="ri-arrow-right-line text-base" />
          </Link>
        </div>
        <div className="grid grid-cols-2 gap-4 self-center">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg border border-background-200 bg-background-50 p-5 text-center"
            >
              <div className="font-heading text-3xl font-extrabold text-primary-700">
                {stat.value}
              </div>
              <div className="mt-2 text-xs text-foreground-500">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}